import { ColumnType } from "../types/table-type";
import { AggregateFunctions } from "../types/form-type";

export const AGG_FUNCTIONS_BASIC = [
  { name: "dropdown.aggregate.filled", value: AggregateFunctions.FILLED },
  { name: "dropdown.aggregate.percentageFilled", value: AggregateFunctions.PERCENTAGE_FILLED },
  { name: "dropdown.aggregate.empty", value: AggregateFunctions.EMPTY },
  { name: "dropdown.aggregate.percentageEmpty", value: AggregateFunctions.PERCENTAGE_EMPTY },
];

export const AGG_FUNCTIONS_TEXT = [
  { name: "dropdown.aggregate.filled", value: AggregateFunctions.FILLED },
  { name: "dropdown.aggregate.percentageFilled", value: AggregateFunctions.PERCENTAGE_FILLED },
  { name: "dropdown.aggregate.empty", value: AggregateFunctions.EMPTY },
  { name: "dropdown.aggregate.percentageEmpty", value: AggregateFunctions.PERCENTAGE_EMPTY },
  { name: "dropdown.aggregate.unique", value: AggregateFunctions.UNIQUE },
  { name: "dropdown.aggregate.percentageUnqiue", value: AggregateFunctions.PERCENTAGE_UNIQUE },
];

export const AGG_FUNCTIONS_NUMBER = [
  { name: "dropdown.aggregate.sum", value: AggregateFunctions.SUM },
  { name: "dropdown.aggregate.average", value: AggregateFunctions.AVERAGE },
  { name: "dropdown.aggregate.median", value: AggregateFunctions.MEDIAN },
  { name: "dropdown.aggregate.min", value: AggregateFunctions.MIN },
  { name: "dropdown.aggregate.max", value: AggregateFunctions.MAX },
  { name: "dropdown.aggregate.range", value: AggregateFunctions.RANGE },
  { name: "dropdown.aggregate.standardDeviation", value: AggregateFunctions.STANDARD_DEVIATION },
  { name: "dropdown.aggregate.filled", value: AggregateFunctions.FILLED },
  { name: "dropdown.aggregate.percentageFilled", value: AggregateFunctions.PERCENTAGE_FILLED },
  { name: "dropdown.aggregate.empty", value: AggregateFunctions.EMPTY },
  { name: "dropdown.aggregate.percentageEmpty", value: AggregateFunctions.PERCENTAGE_EMPTY },
  { name: "dropdown.aggregate.unique", value: AggregateFunctions.UNIQUE },
  { name: "dropdown.aggregate.percentageUnqiue", value: AggregateFunctions.PERCENTAGE_UNIQUE },
];

export const AGG_FUNCTIONS_DATE = [
  { name: "dropdown.aggregate.earliestDate", value: AggregateFunctions.EARLIEST_DATE },
  { name: "dropdown.aggregate.latestDate", value: AggregateFunctions.LATEST_DATE },
  { name: "dropdown.aggregate.dateRangeDays", value: AggregateFunctions.DATE_RANGE_DAYS },
  { name: "dropdown.aggregate.dateRangeMonth", value: AggregateFunctions.DATE_RANGE_MONTH },
  { name: "dropdown.aggregate.filled", value: AggregateFunctions.FILLED },
  { name: "dropdown.aggregate.percentageFilled", value: AggregateFunctions.PERCENTAGE_FILLED },
  { name: "dropdown.aggregate.empty", value: AggregateFunctions.EMPTY },
  { name: "dropdown.aggregate.percentageEmpty", value: AggregateFunctions.PERCENTAGE_EMPTY },
  { name: "dropdown.aggregate.unique", value: AggregateFunctions.UNIQUE },
  { name: "dropdown.aggregate.percentageUnqiue", value: AggregateFunctions.PERCENTAGE_UNIQUE },
];

export const AGG_FUNCTIONS_MULTI_ATTACHMENT = [
  { name: "dropdown.aggregate.filled", value: AggregateFunctions.FILLED },
  { name: "dropdown.aggregate.percentageFilled", value: AggregateFunctions.PERCENTAGE_FILLED },
  { name: "dropdown.aggregate.empty", value: AggregateFunctions.EMPTY },
  { name: "dropdown.aggregate.percentageEmpty", value: AggregateFunctions.PERCENTAGE_EMPTY },
];

export const AGG_FUNCTIONS_CHECKBOX = [
  { name: "dropdown.aggregate.checked", value: AggregateFunctions.CHECKED },
  { name: "dropdown.aggregate.percentageChecked", value: AggregateFunctions.PERCENTAGE_CHECKED },
  { name: "dropdown.aggregate.unchecked", value: AggregateFunctions.UNCHECKED },
  {
    name: "dropdown.aggregate.percentageUnchecked",
    value: AggregateFunctions.PERCENTAGE_UNCHECKED,
  },
];

export const AGGFUNC_LOOKUP_FLATTEN_TYPES: { [key in AggregateFunctions]: boolean } = {
  [AggregateFunctions.UNIQUE]: true,
  [AggregateFunctions.PERCENTAGE_UNIQUE]: true,
  [AggregateFunctions.SUM]: true,
  [AggregateFunctions.AVERAGE]: true,
  [AggregateFunctions.MEDIAN]: true,
  [AggregateFunctions.MAX]: true,
  [AggregateFunctions.MIN]: true,
  [AggregateFunctions.RANGE]: true,
  [AggregateFunctions.STANDARD_DEVIATION]: true,
  [AggregateFunctions.EARLIEST_DATE]: true,
  [AggregateFunctions.LATEST_DATE]: true,
  [AggregateFunctions.DATE_RANGE_DAYS]: true,
  [AggregateFunctions.DATE_RANGE_MONTH]: true,
  [AggregateFunctions.EMPTY]: false,
  [AggregateFunctions.FILLED]: false,
  [AggregateFunctions.PERCENTAGE_EMPTY]: false,
  [AggregateFunctions.PERCENTAGE_FILLED]: false,
  [AggregateFunctions.CHECKED]: false,
  [AggregateFunctions.UNCHECKED]: false,
  [AggregateFunctions.PERCENTAGE_CHECKED]: false,
  [AggregateFunctions.PERCENTAGE_UNCHECKED]: false,
  [AggregateFunctions.COUNT]: false,
};

export const AGG_MATH_TYPES: { [key in AggregateFunctions]: boolean } = {
  [AggregateFunctions.SUM]: true,
  [AggregateFunctions.AVERAGE]: true,
  [AggregateFunctions.MEDIAN]: true,
  [AggregateFunctions.MAX]: true,
  [AggregateFunctions.MIN]: true,
  [AggregateFunctions.RANGE]: true,
  [AggregateFunctions.STANDARD_DEVIATION]: true,
  [AggregateFunctions.EARLIEST_DATE]: true,
  [AggregateFunctions.LATEST_DATE]: true,
  [AggregateFunctions.UNIQUE]: false,
  [AggregateFunctions.PERCENTAGE_UNIQUE]: false,
  [AggregateFunctions.EMPTY]: false,
  [AggregateFunctions.FILLED]: false,
  [AggregateFunctions.PERCENTAGE_EMPTY]: false,
  [AggregateFunctions.PERCENTAGE_FILLED]: false,
  [AggregateFunctions.CHECKED]: false,
  [AggregateFunctions.UNCHECKED]: false,
  [AggregateFunctions.PERCENTAGE_CHECKED]: false,
  [AggregateFunctions.PERCENTAGE_UNCHECKED]: false,
  [AggregateFunctions.DATE_RANGE_DAYS]: false,
  [AggregateFunctions.DATE_RANGE_MONTH]: false,
  [AggregateFunctions.COUNT]: false,
};

export const AGG_OPTION_COLUMN_TYPE: { [key in ColumnType]: { name: string; value: AggregateFunctions }[] } = {
  [ColumnType.TEXT]: AGG_FUNCTIONS_TEXT,
  [ColumnType.LONG_TEXT]: AGG_FUNCTIONS_TEXT,
  [ColumnType.DATETIME]: AGG_FUNCTIONS_DATE,
  [ColumnType.STATUS]: AGG_FUNCTIONS_TEXT,
  [ColumnType.SELECT]: AGG_FUNCTIONS_TEXT,
  [ColumnType.MULTI_SELECT]: AGG_FUNCTIONS_BASIC,
  [ColumnType.MULTI_ATTACHMENT]: AGG_FUNCTIONS_MULTI_ATTACHMENT,
  [ColumnType.RECORD_REFERENCE]: AGG_FUNCTIONS_BASIC,
  [ColumnType.LOOKUP]: [],
  [ColumnType.ROLLUP]: AGG_FUNCTIONS_TEXT,
  [ColumnType.NUMBER]: AGG_FUNCTIONS_NUMBER,
  [ColumnType.CURRENCY]: AGG_FUNCTIONS_NUMBER,
  [ColumnType.FORMULA]: AGG_FUNCTIONS_TEXT,
  [ColumnType.COLLABORATOR]: AGG_FUNCTIONS_BASIC,
  [ColumnType.CHECKBOX]: AGG_FUNCTIONS_CHECKBOX,
  [ColumnType.RATING]: AGG_FUNCTIONS_NUMBER,
  [ColumnType.PHONE]: AGG_FUNCTIONS_TEXT,
  [ColumnType.EMAIL]: AGG_FUNCTIONS_TEXT,
  [ColumnType.NOOP]: [],
  [ColumnType.UNIQUE_ID]: [],
  [ColumnType.AUTO_NUMBER]: AGG_FUNCTIONS_NUMBER,
  [ColumnType.CREATED_AT]: AGG_FUNCTIONS_DATE,
  [ColumnType.CREATED_BY]: AGG_FUNCTIONS_BASIC,
};

export const AGG_OPTION_LOOKUP_COLUMN_TYPE: { [key in ColumnType]?: { name: string; value: AggregateFunctions }[] } = {
  [ColumnType.TEXT]: AGG_FUNCTIONS_BASIC,
  [ColumnType.CHECKBOX]: AGG_FUNCTIONS_BASIC,
  [ColumnType.STATUS]: AGG_FUNCTIONS_TEXT,
  [ColumnType.SELECT]: AGG_FUNCTIONS_TEXT,
  [ColumnType.MULTI_ATTACHMENT]: AGG_FUNCTIONS_BASIC,
  [ColumnType.MULTI_SELECT]: AGG_FUNCTIONS_BASIC,
  [ColumnType.COLLABORATOR]: AGG_FUNCTIONS_BASIC,
  [ColumnType.RECORD_REFERENCE]: AGG_FUNCTIONS_BASIC,
  [ColumnType.NUMBER]: AGG_FUNCTIONS_NUMBER,
  [ColumnType.AUTO_NUMBER]: AGG_FUNCTIONS_NUMBER,
  [ColumnType.CREATED_BY]: AGG_FUNCTIONS_BASIC,
};

export const AGG_OPTION_FORMULA_COLUMN_TYPE: { [key in ColumnType]?: { name: string; value: AggregateFunctions }[] } = {
  [ColumnType.NUMBER]: AGG_FUNCTIONS_NUMBER,
  [ColumnType.CURRENCY]: AGG_FUNCTIONS_NUMBER,
  [ColumnType.DATETIME]: AGG_FUNCTIONS_DATE,
  [ColumnType.TEXT]: AGG_FUNCTIONS_TEXT,
  [ColumnType.CREATED_AT]: AGG_FUNCTIONS_DATE,
};

// 是否拆分value进行计算
export const SPLIT_VALUE_BY_AGGREGATE_TYPE: { [key in AggregateFunctions]?: boolean } = {
  [AggregateFunctions.COUNT]: false,
  [AggregateFunctions.EMPTY]: false,
  [AggregateFunctions.FILLED]: false,
  [AggregateFunctions.UNIQUE]: false,
  [AggregateFunctions.PERCENTAGE_EMPTY]: false,
  [AggregateFunctions.PERCENTAGE_FILLED]: false,
  [AggregateFunctions.PERCENTAGE_UNIQUE]: false,
  // 以此分界 上面是确定是否拆分的 下面是不拆分的
  [AggregateFunctions.SUM]: true,
  [AggregateFunctions.AVERAGE]: true,
  [AggregateFunctions.MEDIAN]: true,
  [AggregateFunctions.MAX]: true,
  [AggregateFunctions.MIN]: true,
  [AggregateFunctions.RANGE]: true,
  [AggregateFunctions.STANDARD_DEVIATION]: true,
  [AggregateFunctions.EARLIEST_DATE]: true,
  [AggregateFunctions.LATEST_DATE]: true,
  [AggregateFunctions.CHECKED]: true,
  [AggregateFunctions.UNCHECKED]: true,
  [AggregateFunctions.PERCENTAGE_CHECKED]: true,
  [AggregateFunctions.PERCENTAGE_UNCHECKED]: true,
  [AggregateFunctions.DATE_RANGE_DAYS]: true,
  [AggregateFunctions.DATE_RANGE_MONTH]: true,
};
